import { render, staticRenderFns } from "./dialog-save.vue?vue&type=template&id=26e8497d&"
import script from "./dialog-save.vue?vue&type=script&lang=js&"
export * from "./dialog-save.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports